/**
 * Converia.Core.module
 *
 * Converia.SiteStructure.Column
 */

Converia.Core.module('Converia.SiteStructure.Column', function () {
    /**
     * Column
     * 
     * @param articles
     * @constructor
     */
    var Column = function (articles) {
        this.articles = articles;
    };

    /**
     * Column.prototype.addArticle
     * 
     * @param article
     */
    Column.prototype.addArticle = function (article) {
        this.articles.push(article);
    };

    /**
     * Column.prototype.toJson
     * 
     * @returns {Array}
     */
    Column.prototype.toJson = function () {
        var rawJson = [];

        for (var articleIndex = 0, articleLength = this.articles.length; articleIndex < articleLength; articleIndex++) {
            rawJson.push(this.articles[articleIndex].toJson());
        }

        return rawJson;
    };

    /**
     * Column.prototype.getArticles
     * 
     * @returns {Array}
     */
    Column.prototype.getArticles = function () {
        return this.articles;
    };

    /**
     * Column.prototype.removeArticleWithIndex
     * 
     * @param index
     */
    Column.prototype.removeArticleWithIndex = function (index) {
        if (index >= this.articles.length) {
            throw new Error('Article not found to delete.');
        }

        this.articles.splice(index, 1);
    };

    /**
     * Column.prototype.removeArticleWithIndex
     *
     * @param index
     * @return Converia.SiteStructure.Article
     */
    Column.prototype.getArticleWithIndex = function (index) {
        if (index >= this.articles.length) {
            throw new Error('Article not found to delete.');
        }

        return this.articles[index];
    };

    /**
     * Column.prototype.setNewArticleOrder
     * 
     * @param newOrder
     */
    Column.prototype.setNewArticleOrder = function (newOrder) {
        if (newOrder.length !== this.articles.length) {
            throw new Error('Article list length missmatch.');
        }

        var articlesSorted = [];

        for (var i=0, len=newOrder.length; i<len;i++) {
            var oldIndex = newOrder[i];
            articlesSorted.push(this.articles[oldIndex]);
        }

        this.articles = articlesSorted;
    };

    return Column;
});
